import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import moment from 'jalali-moment';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const MySwal = withReactContent(Swal);

export default class Consultation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      search: '',
      filterPosts:[],
      fromDate: '',
      toDate: '',
      isFilter: false,
      postsLength: null,
      filteredLength: null
    };
    this.getPost();
  }

  fromDateHandler(value){
    this.setState({ fromDate: value})
  }
  toDateHandler(value){
    this.setState({ toDate: value})
  }

  filterByTime() {
    axios
      .post("https://arianaapp.arianaapply.com/panel/report/number-resume", {
        startTime: moment(new Date(this.state.fromDate), "yyyy-mm-dd")
          .locale("en")
          .format("YYYY-MM-DD"),
        endTime: moment(new Date(this.state.toDate), "yyyy-mm-dd")
          .locale("en")
          .format("YYYY-MM-DD"),
      })
      .then((res) => {
        console.log("res", res);
        this.setState({isFilter: true, filterPosts: res.data.data[0], filteredLength: res.data.data[0].length})
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <div className='index'>
        <div className='table'>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              margin: '1rem 0',
            }}>
            <input
              className='search-input'
              type='search'
              name='search'
              value={this.state.search}
              placeholder='جستجو کنید....'
              onChange={(e) => this.setState({ search: e.target.value })}
            />
          </div>
          <div className="time-filter">
            <h4>فیلتر بر اساس زمان:</h4>
            <div className="time-filter-inputs">
              <div style={{ direction: "rtl" }}>
                <label>از تاریخ:</label>
                <DatePicker
                  value={this.state.fromDate}
                  onChange={(v)=> this.fromDateHandler(v)}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-center"
                />
              </div>
              <div>
                <label>تا تاریخ:</label>
                <DatePicker
                  value={this.state.toDate}
                  onChange={(v)=> this.toDateHandler(v)}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-center"
                />
              </div>
            </div>
            <button
              className="success filter-date-btn"
              onClick={() => this.filterByTime()}
            >
              فیلتر
            </button>
            {this.state.isFilter && (
              <button
                className="danger filter-date-btn"
                onClick={()=> this.setState({isFilter: false})}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            )}
          </div>
          <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                margin: "1rem 0",
                fontSize: '20px'
              }}
            >
              <span>تعداد: {!this.state.isFilter ? this.state.postsLength : this.state.filteredLength}</span>
              </div>
          <table>
            <thead>
              <tr>
                <td>#</td>
                <td>نام</td>
                <td>سن</td>
                <td>تلفن</td>
                <td>تحصیلات</td>
                <td>بودجه</td>
                <td>مدرک زبان</td>
                <td>ایمیل</td>
                <td>تاریخ</td>
              </tr>
            </thead>
            <tbody>
              {
              !this.state.isFilter ?
              this.state.posts
                .filter((p) => p.name.toLowerCase().includes(this.state.search))
                .map((item, index) =>(
                  <tr key={item._id}>
                    <td>{index}</td>
                    <td>{item.name}</td>
                    <td>{item.age}</td>
                    <td>{item.phone}</td>
                    <td>{item.education}</td>
                    <td>{item.budget}</td>
                    <td>{item.language}</td>
                    <td>{item.email}</td>
                    <td>
                      {moment(item.created_at, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                    </td>
                  </tr>
                )):
                this.state.filterPosts.map((item, index) =>(
                  <tr key={item._id}>
                    <td>{index}</td>
                    <td>{item.name}</td>
                    <td>{item.age}</td>
                    <td>{item.phone}</td>
                    <td>{item.education}</td>
                    <td>{item.budget}</td>
                    <td>{item.language}</td>
                    <td>{item.email}</td>
                    <td>
                      {moment(item.created_at, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderItem(item, i) {
    return (
      <tr key={item._id}>
        <td>{i}</td>
        <td>{item.name}</td>
        <td>{item.age}</td>
        <td>{item.phone}</td>
        <td>{item.education}</td>
        <td>{item.budget}</td>
        <td>{item.language}</td>
        <td>{item.email}</td>
        <td>
          {moment(item.created_at, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD')}
        </td>
      </tr>
    );
  }

  getPost() {
    axios
      .get('https://arianaapp.arianaapply.com/panel/get-consultations')
      .then((response) => {
        console.log(response);
        this.setState({ posts: response.data.data.reverse(), postsLength: response.data.length });
      })
      .catch((err) => {
        console.log(err);

        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  }
}
